import { Box, Typography } from '@mui/material'
import { useRoleList } from '../../assets/api/useAdminApi'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'

const RoleList = () => {
    const { data: roleList, isLoading } = useRoleList()
    const roleRows = roleList?.roles?.map((item, index) => ({
        sr_no: index + 1,
        id: index + 1,
        role: item
    })) || [];

    const roleColumns = [
        {
            field: "id",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "role",
            headerName: "Role",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
    ];
    return (
        <Box>
          
         <TableFilterTemplate
                title="Role List"
                columns={roleColumns}
                rowsData={roleRows || []}
                isLoading={isLoading}
               
            />
        </Box>
    )
}

export default RoleList